import { useNavigate } from "@tanstack/react-router";
import { ArrowRight, Laptop, Moon, Sun } from "lucide-react";
import React from "react";
import {
	CommandDialog,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
	CommandSeparator,
} from "@/components/ui/command";
/*import {
  IconArrowRightDashed,
  IconDeviceLaptop,
  IconMoon,
  IconSun,
} from '@tabler/icons-react'*/
import { useSearch } from "@/context/search-context";
import { useTheme } from "@/context/theme-context";
import { sidebarData } from "./layout/data/sidebar-data";
import { ScrollArea } from "./ui/scroll-area";

export function CommandMenu() {
	const navigate = useNavigate();
	const { setTheme } = useTheme();
	const { open, setOpen } = useSearch();

	const runCommand = React.useCallback(
		(command: () => unknown) => {
			setOpen(false);
			command();
		},
		[setOpen],
	);

	return (
		<CommandDialog modal onOpenChange={setOpen} open={open}>
			<CommandInput placeholder="Type a command or search..." />
			<CommandList>
				<ScrollArea className="h-72 pr-1" type="hover">
					<CommandEmpty>No results found.</CommandEmpty>
					{sidebarData.navGroups.map((group) => (
						<CommandGroup heading={group.title} key={group.title}>
							{group.items.map((navItem, itemIndex) => {
								if (navItem.url) {
									return (
										<CommandItem
											key={`${navItem.url}-${itemIndex}`}
											onSelect={() => {
												runCommand(() => navigate({ to: navItem.url }));
											}}
											value={navItem.title}
										>
											<div className="mr-2 flex size-4 items-center justify-center">
												<ArrowRight className="size-2 text-muted-foreground/80" />
											</div>
											{navItem.title}
										</CommandItem>
									);
								}

								return navItem.items?.map((subItem, subIndex) => (
									<CommandItem
										key={`${subItem.url}-${subIndex}`}
										onSelect={() => {
											runCommand(() => navigate({ to: subItem.url }));
										}}
										value={subItem.title}
									>
										<div className="mr-2 flex size-4 items-center justify-center">
											<ArrowRight className="size-2 text-muted-foreground/80" />
										</div>
										{subItem.title}
									</CommandItem>
								));
							})}
						</CommandGroup>
					))}
					<CommandSeparator />
					<CommandGroup heading="Theme">
						<CommandItem onSelect={() => runCommand(() => setTheme("light"))}>
							<Sun /> <span>Light</span>
						</CommandItem>
						<CommandItem onSelect={() => runCommand(() => setTheme("dark"))}>
							<Moon className="scale-90" />
							<span>Dark</span>
						</CommandItem>
						<CommandItem onSelect={() => runCommand(() => setTheme("system"))}>
							<Laptop />
							<span>System</span>
						</CommandItem>
					</CommandGroup>
				</ScrollArea>
			</CommandList>
		</CommandDialog>
	);
}
